import styled from 'styled-components'

export const ResourceListWrap = styled.div`
`
